import type { MasterdataProduct } from '@softapps/core/masterdata';

/** Which draft field produced the hit — shown as the reason in the review. */
export type ProductMatchVia = 'ean' | 'supplier_number' | 'key' | 'name' | 'manual';

/**
 * Match state of ONE position draft. `matched` (unambiguous or user-assigned)
 * exports as that product; `manual` books the row on the supplier's Manueller
 * Artikel; `text` exports it as a text position without an article;
 * `suggested` carries the candidates the user picks from in the "Zuordnen"
 * dialog; `none` is undecided — the export gate settles it before anything is
 * created.
 */
export type PositionMatch =
  | { status: 'pending' }
  | { status: 'none' }
  | {
      status: 'suggested';
      product: MasterdataProduct;
      via: ProductMatchVia;
      candidates: MasterdataProduct[];
    }
  | { status: 'matched'; product: MasterdataProduct; via: ProductMatchVia }
  | { status: 'manual' }
  | { status: 'text' };

/** Default for a draft nobody has looked up yet. */
export const NO_MATCH: PositionMatch = { status: 'none' };
export const MANUAL_MATCH: PositionMatch = { status: 'manual' };
export const TEXT_MATCH: PositionMatch = { status: 'text' };

/** The user (or an unambiguous hit) settled this row. */
export function isDecided(match: PositionMatch): boolean {
  return (
    match.status === 'matched' || match.status === 'manual' || match.status === 'text'
  );
}
